import axios from 'axios';

// Получаем токен из localStorage
const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Создаем экземпляр axios с базовым URL
const axiosInstance = axios.create({
  baseURL: '/api'
});

const API_URL = '/statuses';

// Получение всех статусов проекта
export const getProjectStatuses = async (projectId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/project/${projectId}`, {
      headers: getAuthHeader()
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching project statuses:', error);
    throw error;
  }
};

// Создание нового статуса
export const createStatus = async (projectId, statusData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/project/${projectId}`, statusData, {
      headers: getAuthHeader()
    });
    return response.data;
  } catch (error) {
    console.error('Error creating status:', error);
    throw error;
  }
};

// Обновление статуса
export const updateStatus = async (statusId, statusData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/${statusId}`, statusData, {
      headers: getAuthHeader()
    });
    return response.data;
  } catch (error) {
    console.error('Error updating status:', error);
    throw error;
  }
};

// Удаление статуса
export const deleteStatus = async (statusId) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/${statusId}`, {
      headers: getAuthHeader()
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting status:', error);
    throw error;
  }
};

// Изменение порядка статусов
export const reorderStatuses = async (projectId, statusIds) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/project/${projectId}/reorder`, { statusOrder: statusIds }, {
      headers: getAuthHeader()
    });
    return response.data;
  } catch (error) {
    console.error('Error reordering statuses:', error);
    throw error;
  }
};

export default {
  getProjectStatuses,
  createStatus,
  updateStatus,
  deleteStatus,
  reorderStatuses
};
